<div class="header-container">
  <app-header></app-header>
</div>

<main class="content-container">
  <app-error-info [errorInfo]="errorInfo"></app-error-info>
</main>
